export const AdultTypes = [
    { value: '1', label: '1 Adult' },
    { value: '2', label: '2 Adults' },
    { value: '3', label: '3 Adults' },
    { value: '4', label: '4 Adults' },
    { value: '5', label: '5 Adults' },
    { value: '6', label: '6 Adults' },
    { value: '7', label: '7 Adults' },
    { value: '8', label: '8 Adults' },
    { value: '9', label: '9 Adults' },
    { value: '10', label: '10 Adults' },
    { value: '11', label: '11 Adults' },
    { value: '12', label: '12 Adults' },
    { value: '13', label: '13 Adults' },
    { value: '14', label: '14 Adults' },
    { value: '15', label: '15 Adults' },
    { value: '16', label: '16 Adults' },
    { value: '17', label: '17 Adults' },
    { value: '18', label: '18 Adults' },
    { value: '19', label: '19 Adults' },
    { value: '20', label: '20 Adults' }
];

export type AdultType = typeof AdultTypes[number]['value']